import React from 'react';
import { Sample } from '../../types';
import { Printer } from 'lucide-react';

interface LabelModalProps {
  sample: Sample;
  onClose: () => void;
  onPrint: () => void;
}

const LabelModal: React.FC<LabelModalProps> = ({ sample, onClose, onPrint }) => {
  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4 print:p-0 print:bg-white print:inset-0">
      <div className="bg-white rounded-xl shadow-xl w-full max-w-sm overflow-hidden flex flex-col print:shadow-none print:w-full print:max-w-none print:h-full print:rounded-none">
        <div className="px-6 py-4 border-b border-slate-200 bg-slate-50 flex justify-between items-center print:hidden">
          <h3 className="font-bold text-lg text-slate-800">Étiquette Code-Barres</h3>
          <button onClick={onClose} className="text-slate-400 hover:text-slate-600">&times;</button>
        </div>
        
        <div className="p-8 flex flex-col items-center justify-center print:p-0 print:absolute print:top-0 print:left-0">
           {/* Label Simulation */}
           <div className="border-2 border-slate-800 p-4 w-64 rounded-lg flex flex-col items-center bg-white print:border-none">
              <h4 className="font-bold text-lg border-b-2 border-slate-800 w-full text-center pb-1 mb-2">SIL IPM</h4>
              <div className="w-full text-left space-y-1 mb-3">
                 <p className="font-bold text-sm truncate">{sample.patients?.last_name} {sample.patients?.first_name}</p>
                 <p className="font-mono text-xs">PAT: {sample.patients?.unique_id}</p>
                 <p className="font-mono text-xs">ECH: {sample.id.slice(0, 8).toUpperCase()}</p>
                 <p className="text-xs">{new Date(sample.collection_date).toLocaleDateString()}</p>
                 <p className="text-xs font-semibold">{sample.sample_type}</p>
              </div>
              {/* Fake Barcode Visual */}
              <div className="flex justify-between w-full h-12 bg-slate-100 px-2 items-end pb-1 gap-0.5">
                 {[...Array(30)].map((_, i) => (
                     <div key={i} className="bg-slate-900 w-1" style={{ height: `${Math.random() * 60 + 40}%`}}></div>
                 ))}
              </div>
              <p className="text-[10px] font-mono mt-1 tracking-widest">{sample.id.slice(0,12).toUpperCase()}</p>
           </div>

           <div className="mt-8 flex gap-3 print:hidden">
              <button onClick={onClose} className="px-4 py-2 text-slate-600 hover:bg-slate-100 rounded-lg">Fermer</button>
              <button onClick={onPrint} className="px-4 py-2 bg-slate-900 text-white rounded-lg flex items-center gap-2 hover:bg-slate-800">
                 <Printer size={16} /> Imprimer
              </button>
           </div>
        </div>
      </div>
    </div>
  );
};

export default LabelModal;